import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { API } from "../api";

export const teamInvitationsQueryOptions = () =>
  queryOptions({
    queryKey: ["teamInvitations"],
    queryFn: async () => {
      const response = await API.invitations.invitationsControllerFindAll();

      return response.data;
    },
    refetchInterval: 5000,
  });

export const useTeamInvitations = () => {
  return useQuery(teamInvitationsQueryOptions());
};

export const useTeamInvitationsSuspense = () => {
  return useSuspenseQuery(teamInvitationsQueryOptions());
};
